import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const DailyStatReportServices = {
  // GET /dailystatsreport/today
  getList: async () => {
    try {
      const response = await apiService.get("/dailystatsreport/today", {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching daily stats report:", error);
      throw error;
    }
  },
};

export default DailyStatReportServices;
